module.exports = __webpack_public_path__ + "static/img/rank_85.38f4bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_85.png
// module id = jauS
// module chunks = 0